import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import MainLoader from './App/MainLoader'
import Layout from './App/Layout'

import fetchMerchantInfo from './Header/actions/async'

class PublicRoute extends Component {
  componentDidMount() {
    const { fetchInitialProps } = this.props
    fetchInitialProps()
  }

  renderComponents = () => {
    const {
      isUserLoggedIn,
      component: Components,
      isLoading,
      CustomDomainMerchant,
    } = this.props

    if (CustomDomainMerchant) {
      window.location.replace(`https://${CustomDomainMerchant}`)
    }
    if (isLoading) {
      return (
        <MainLoader />
      )
    }
    if (isUserLoggedIn) {
      return (
        <Redirect to='/orders' />
      )
    }
    return (
      <Layout restrictedRoute={false}>
        <Components />
      </Layout>
    )
  }

  render() {
    const { path } = this.props

    return (
      <Route
        path={path}
        render={() => this.renderComponents()}
      />
    )
  }
}

PublicRoute.propTypes = {
  CustomDomainMerchant: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  fetchInitialProps: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  isLoading: state.LoadingMerchant.isLoading,
  isUserLoggedIn: state.user.isUserLoggedIn,
  CustomDomainMerchant: state.merchant.redirect_url || '',
})

const mapDispatchToProps = (dispatch) => ({
  fetchInitialProps: () => {
    dispatch(fetchMerchantInfo())
  },
})

const PublicRoutes = connect(mapStateToProps, mapDispatchToProps)(PublicRoute)

export default PublicRoutes
